import React, { useEffect } from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { CircularProgress, Typography } from '@mui/material'
import Box from '@mui/material/Box'
import { useAppDispatch, useAppSelector } from 'store'

import NotPermittedPage from 'pages/errorPages/notPermittedPage'
import { getBrandsAssets } from 'services/assetsSlice'
import {
  getProfile,
  getUserToken,
  selectAuthStatus,
  selectUserPermissions
} from 'services/authSlice'
import { isUserAuthorisedToPath } from 'types/lib/auth'
import { LoadingStatus } from 'types/user'
import { PATHS } from 'utils/paths'
import { isNilOrEmpty, isNotNilOrEmpty } from 'utils/ramda'

export const PrivateRoutes = () => {
  const dispatch = useAppDispatch()
  const userToken = useAppSelector(getUserToken)
  const authStatus = useAppSelector(selectAuthStatus)
  const userPermissions = useAppSelector(selectUserPermissions)
  const { pathname } = useLocation()

  useEffect(() => {
    if (isNotNilOrEmpty(userToken)) {
      dispatch(getProfile())
    }
    dispatch(getBrandsAssets())
  }, [dispatch, userToken])

  const hasToken = isNotNilOrEmpty(userToken)
  const permissionsReady = !isNilOrEmpty(userPermissions)
  const sessionBootstrapping =
    hasToken &&
    !permissionsReady &&
    authStatus !== LoadingStatus.failed

  if (!hasToken) {
    return <Navigate to={PATHS.login} replace />
  }

  if (sessionBootstrapping) {
    return (
      <Box
        flexDirection={'column'}
        display={'flex'}
        width={'100vw'}
        height={'100vh'}
        alignItems={'center'}
        justifyContent={'center'}
      >
        <CircularProgress size={48} />
        <Box mt={2}>
          <Typography>Loading, please wait...</Typography>
        </Box>
      </Box>
    )
  }

  if (!permissionsReady) {
    return <Navigate to={PATHS.login} replace />
  }

  return isUserAuthorisedToPath(pathname, userPermissions) ? (
    <Outlet />
  ) : (
    <NotPermittedPage />
  )
}
